export default __webpack_public_path__ + "static/media/q2_07.70200c6a.png";